import { jsx as _jsx } from "react/jsx-runtime";
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
const DefaultContainer = (props)=>{
    const containerStyles = props?.params?.Styles ?? '';
    const styles = `${props?.params?.GridParameters} ${containerStyles}`.trimEnd();
    const phKey = `container-${props?.params?.DynamicPlaceholderId}`;
    const id = props?.params?.RenderingIdentifier;
    const mediaUrlPattern = new RegExp(/mediaurl=\"([^"]*)\"/, 'i');
    const backgroundImage = props?.params?.BackgroundImage;
    let backgroundStyle = {};
    if (backgroundImage && backgroundImage.match(mediaUrlPattern)) {
        const mediaUrl = backgroundImage.match(mediaUrlPattern)?.[1] || '';
        backgroundStyle = {
            backgroundImage: `url('${mediaUrl}')`
        };
    }
    return /*#__PURE__*/ _jsx("div", {
        className: `component container-default ${styles}`,
        id: id ? id : undefined,
        children: /*#__PURE__*/ _jsx("div", {
            className: "component-content",
            style: backgroundStyle,
            children: /*#__PURE__*/ _jsx("div", {
                className: "row",
                children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                    name: phKey,
                    rendering: props.rendering
                })
            })
        })
    });
};
export const Default = (props)=>{
    const splitStyles = props.params?.Styles?.split(' ');
    if (splitStyles && splitStyles.includes('container')) {
        return /*#__PURE__*/ _jsx("div", {
            className: "container-wrapper",
            children: /*#__PURE__*/ _jsx(DefaultContainer, {
                ...props
            })
        });
    }
    return /*#__PURE__*/ _jsx(DefaultContainer, {
        ...props
    });
};
